import MagicEditor from "components/layout/MagicEditor";
import { useEffect, useRef, useState } from "react";
import { HiOutlinePencil } from "react-icons/hi2";
import useOnClickOutside from "utils/hooks/useOnClickOutside";

const TitlePreview = ({
    title,
    network,
    post = undefined,
    isEditable = false,
    onTitleEdit = undefined
}) => {

    const [ isEditing, setIsEditing ] = useState(false);
    const [ value, setValue ] = useState(title);
    const [ valueOnEdit, setValueOnEdit ] = useState(title);
    const wrapperRef = useRef();

    const onCancel = () => {
        setValue(valueOnEdit);
        setIsEditing(false);
    }

    const onConfirm = () => {
        onTitleEdit && onTitleEdit(value);
        setIsEditing(false);
    }

    useOnClickOutside(wrapperRef, () => {
        onTitleEdit && onTitleEdit(value);
        setIsEditing(false);
    }, [value]);

    useEffect(() => {
        if (isEditing == true) {
            setValueOnEdit(value);
        }
    }, [isEditing]);

    useEffect(() => {
        if (title != value) {
            setValue(title);
        }
    }, [title]);

    return (
        <div className="text-tertiary-800 dark:text-gray-50 !text-base">
            {!isEditing 
                ? <div key={title} className={`${isEditable && `group cursor-pointer`} ${(!value || !value?.trim()) && `mb-2`} inline-block`} onClick={() => isEditable && setIsEditing(true)}>
                    <span className={`inline text-[32px] leading-[42px] font-black group-hover:bg-tertiary-100 dark:group-hover:bg-gray-900 ${(!value || !value?.trim()) && `text-tertiary-400 dark:text-gray-600 italic`}`} dangerouslySetInnerHTML={{__html: value?.trim() || value || (isEditable ? "Click here to add a title to this post..." : ``)}}></span>
                    <span><HiOutlinePencil className="text-tertiary-600 leading-[42px] -mt-2.5 text-2xl ml-1 hidden group-hover:inline" /></span>
                </div>
                : <div className="relative" ref={wrapperRef}>
                    <MagicEditor 
                        value={value}
                        setValue={setValue}
                        network={network}
                        isTitle={true}
                        className="!text-[32px] !leading-[42px] !font-black !p-0 w-full !pb-0 !overflow-y-hidden !bg-secondary-500 dark:!bg-gray-800"
                        footerClassName="!border-0 !px-0 !mt-4 !rounded-xl !rounded-t-xl !rounded-b-xl"
                        onCancel={onCancel}
                        onConfirm={onConfirm}
                        minHeight={10}
                        autoFocus={true}
                        post={post}
                        onKeyDown={(e) => { if (e.key == 'Enter') onConfirm() }}
                    />
                </div>
            }
        </div>
    );
}

export default TitlePreview;